// Function for variant XL - Change image with variants buttons

document.addEventListener("DOMContentLoaded", function(){

    const buttonStandard = document.querySelectorAll('[data-option-position="1"] fieldset > span ')[0]
    const buttonXL = document.querySelectorAll('[data-option-position="1"] fieldset > span ')[1]

    const variantImages = [
      document.getElementById("imageXL11"),
      document.getElementById("imageXL12"),
      document.getElementById("imageXL13"),
      document.getElementById("imageXL14"),
      document.getElementById("imageXL16"),
      document.getElementById("imageXL17"),
      document.getElementById("imageXL18"),
      document.getElementById("imageXL19"),
      document.getElementById("imageXL15"),
      document.getElementById("imageXL20"),
    ];

    const variantImagesThumb = [
      document.getElementById("imageXL-thumbnail11"),
      document.getElementById("imageXL-thumbnail12"),
      document.getElementById("imageXL-thumbnail13"),
      document.getElementById("imageXL-thumbnail14"),
      document.getElementById("imageXL-thumbnail16"),
      document.getElementById("imageXL-thumbnail17"),
      document.getElementById("imageXL-thumbnail18"),
      document.getElementById("imageXL-thumbnail19"),
      document.getElementById("imageXL-thumbnail15"),
      document.getElementById("imageXL-thumbnail20"),
    ];

    //Save Thumbnails standard

    let originalThumbnails = [];

    let saveThummb = document.querySelectorAll("[data-slideshow-thumbnail]")
    
    saveThummb.forEach((thumbnail, index) => {
      originalThumbnails[index] = thumbnail.innerHTML
    });

    const imageChanges = document.querySelectorAll("[data-product-image]");

    //Save price at varian Standard

    const savePriceCompareAt = document.querySelectorAll('.selector-wrapper radio-swatch input')[1].getAttribute("data-compare-at-price")

    //Save standard badge 

    const saveBadgeStandard = document.querySelector('.badgeInfo__text.othersBadge p').textContent

    const changeImage = () => {

      const thumbnailsChange = document.querySelectorAll("[data-slideshow-thumbnail]");


      for (let i = 0; i < variantImagesThumb.length; i++) {
        thumbnailsChange[i].innerHTML = "";
        thumbnailsChange[i].appendChild(variantImagesThumb[i])
      }

      imageChanges.forEach((imageChange, index) => {
        imageChange.parentNode.appendChild(variantImages[index]);
        imageChange.style.borderRadius = "25px";
      });

      variantImagesThumb.forEach((item) => {
        item.style.display = "block";
      });

      setTimeout(() => {
        document.getElementById("imageXL-thumbnail12").click()
      }, 200);

      
      //Change price of compare at price
      const changeCompareAtPrice = document.querySelectorAll('.selector-wrapper radio-swatch input')
      changeCompareAtPrice.forEach(function(variant){
        if(document.querySelector("input[name='options[Size]']:checked").value == "Standard"){
          variant.setAttribute("data-compare-at-price","$499")  
        } else {
          variant.setAttribute("data-compare-at-price","$599")
        }
        
      })
      

      

      // Set new badge text

      const textBadgeXL = document.querySelector(".badgeInfo__text.othersBadge").getAttribute('data-variant-xl-bage')

      document.querySelector('.badgeInfo__text.othersBadge p').textContent = textBadgeXL

    }

    const revertImage = () => {

      if (buttonStandard) {
        variantImages.forEach(image => {
          image.remove();
        })

        const revertThumb = document.querySelectorAll("[data-slideshow-thumbnail]");
        revertThumb.forEach((thumbnail, index) => {
          thumbnail.innerHTML = originalThumbnails[index]
        })
        
        imageChanges.forEach((imageChange) => {
          imageChange.style.borderRadius = "0";
        });

        const changeCompareAtPrice = document.querySelectorAll('.selector-wrapper radio-swatch input')[1]

        //Revert price of compare at price

        changeCompareAtPrice.setAttribute("data-compare-at-price", savePriceCompareAt)

        document.querySelectorAll('radio-swatch label')[1].click()

        //Revert text of badge

        document.querySelector('.badgeInfo__text.othersBadge p').textContent = saveBadgeStandard

      }
        
    }


  if(buttonXL) {
    buttonXL.addEventListener("click", changeImage);
  }

  if(buttonStandard) {
    buttonStandard.addEventListener("click", revertImage);
  }


  // Function for variant size XL modal 


  const iconQestion = document.querySelector(".radio__button-question")
  const modalInfo = document.querySelector(".radio__button-questionModal")

  iconQestion.addEventListener("mouseover", function () {
    if (modalInfo) {
      modalInfo.style.display = "flex"
    }
  })

  iconQestion.addEventListener("mouseout", function () {
    if (modalInfo) {
      modalInfo.style.display = "none"
    }
  })

  // Function hidden select swatchers when target is unavailable

  const checkSwatchers = document.querySelectorAll(".radio__fieldset radio-swatch input")

  function observarInput(input) {

      let config = { attributes: true, childList: false, subtree: false, attributeOldValue: true };

      let callback = function(mutationsList, observer) {
          for(let mutation of mutationsList) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                  if (input.classList.contains('unavailable')) {

                    // Swatchers hidden

                    document.querySelectorAll('.radio__fieldset radio-swatch input.unavailable').forEach((input) => input.parentNode.style.display = "none")
                    
                   // document.querySelectorAll('radio-swatch label')[1].click()

                    //document.getElementById('imageXL-thumbnail1').click()
                    

                  } else {

                    //Revert hidden

                    document.querySelectorAll('.radio__fieldset radio-swatch input').forEach((input) => input.parentNode.style.display = "inline-block")

                  }
              }
          }
      };

      let oberserverSwatchers = new MutationObserver(callback);

      oberserverSwatchers.observe(input, config);
  }

  //select variants to observe

  let inputs = document.querySelectorAll('.radio__fieldset radio-swatch input');

  inputs.forEach(function(input) {
      observarInput(input);
  });
  

})    

document.addEventListener("DOMContentLoaded", function(){
  document.querySelector("label[for='7761328865506-form-Size-X - LARGE']").addEventListener("click", function(){
    setTimeout(function(){
      document.querySelectorAll('radio-swatch label')[1].click()  
      changeImage()
    },100)  	
  })  
  
  document.querySelector("label[for='7761328865506-form-Size-Standard']").addEventListener("click", function(){
    setTimeout(function(){
      const changeCompareAtPrice = document.querySelectorAll('.selector-wrapper radio-swatch input')
      changeCompareAtPrice.forEach(function(variant){
        if(document.querySelector("input[name='options[Size]']:checked").value == "Standard"){
          variant.setAttribute("data-compare-at-price","$499")  
        } else {
          variant.setAttribute("data-compare-at-price","$599")
        }
      })
    },100)  	
  })  
})
